import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LayoutSite } from "./components/layout";
import { LogsPage } from "./pages/logs";
import { LoginPage } from "./pages/login";
import { AuthProvider } from "./services/auth.service";
import "./app.scss";

/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
export default function App()
{
    return (
        <BrowserRouter basename="/">
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<LogsPage />} />
                    <Route path="/logs" element={<LogsPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="*" element={<LayoutSite><p>Wrong page</p></LayoutSite>} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
